import { ISelectionTabPillProps } from "../../properties/TabProperties";
import SelectionTab from "./SelectionTab";

// SelectionTabPill — kept as a named export for existing call sites, but all
// selection tabs now render the unified morph SelectionTab. The legacy
// selected/unselected className props are no longer used.
const SelectionTabPill = ({
  optionList,
  selectedId,
  handleSelectOnClick,
}: ISelectionTabPillProps) => {
  return (
    <SelectionTab
      optionList={optionList}
      selectedId={selectedId}
      handleSelectOnClick={handleSelectOnClick}
    />
  );
};

export default SelectionTabPill;
